<template>
	<div class="dashboard">
		<top-header></top-header>
		<div class="breadcrumb-section mb-5">
			<b-container>
				<b-row>
					<b-col class="text-left">
						<h5 class="mt-3 mb-3">CART</h5>		
					</b-col>
					<b-col class="text-right">
						<h6 class="mt-3 mb-3">HOME / CART</h6>		
					</b-col>
				</b-row>
			</b-container>
		</div>
		<b-container>
			<b-row>
				<b-col>
                    <b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="$root.cart.items" :fields="fields">
                        <template v-slot:cell(image)="row">
                            <b-img v-bind="thumbnailProps" rounded alt="" :src="$root.MEDIAAPI+'tool/get_image?size=80x80&src='+row.item.image"></b-img>
                        </template>
						<template v-slot:cell(title)="row">
                            <h5 class="my-0">{{row.value}}</h5>
                            <p class="my-0">Sold By: {{row.item.shopname}}</p>
                        </template>
                        <template v-slot:cell(price)="row">
							<span v-if="row.item.special_price>0 && row.item.special_price!=null">
                            <h3 class="my-0" >{{$root.currency()+$root.tofixed(row.item.special_price, 2)}}</h3>
                            <p class="my-0"><del>{{$root.currency()+$root.tofixed(row.item.price, 2)}}</del></p>
							</span>
							<span v-else>
									<h3 class="my-0" >{{$root.currency()+$root.tofixed(row.item.price, 2)}}</h3>
							</span>
							
                        </template>
                        <template v-slot:cell(qty)="row">
                            <b-form-spinbutton id="sb-inline" min="1" max="10" step="1" :value="row.item.qty" @change="$root.updateCart(row.item, $event)" inline></b-form-spinbutton>
                        </template>
                        <template v-slot:cell(action)="row">
                            <b-link @click="$root.removeCart(row.item.id)"><b-img src="../assets/cancel.svg" class="icon"></b-img></b-link>
                        </template>
                        <template v-slot:cell(total)="row">
                            <h3 v-if="row.item.special_price>0 && row.item.special_price!=null">{{$root.currency()+$root.tofixed((row.item.special_price * row.item.qty), 2)}}</h3>
                            <h3 v-else>{{$root.currency()+$root.tofixed((row.item.price * row.item.qty), 2)}}</h3>
                        </template>
                    </b-table>
                </b-col>
			</b-row>
            <b-row class="mb-4">
				<b-col>
                    
                </b-col>
                <b-col class="text-right">
                    <h3><small class="mr-4">Total Price: </small>{{$root.currency()+$root.tofixed(($root.cart.subtotal), 2)}}</h3>
                </b-col>
			</b-row>
            <b-row class="mb-4">
				<b-col>
                    <b-link class="btn-solid btn2">Continue Shopping</b-link>
                </b-col>
                <b-col class="text-right">
                    <b-link class="btn-solid btn2" href="/checkout">Checkout</b-link>
                </b-col>
			</b-row>
			<product-swiper :products="related_products" :showQuickViewListener="$root.showQuickView" heading="You may also Interested to Buy"></product-swiper>
		</b-container>
		<top-footer></top-footer>
		<quickview :modaldata="$root.quickview_data"></quickview>
	</div>
</template>
<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import ProductSwiper from "@/components/product-swiper.vue";
import Quickview from "@/components/quickview.vue";
export default {
	name: 'Dashboard',
	beforeRouteEnter (to, from, next) {
		//const app = context.router.app;
		next( async vm => {
			console.log(vm.$root.WEBURL);
			const requestOptions = {
				method: "GET",
				headers: { "Content-Type": "application/json" },
				/*body: JSON.stringify({ title: "Vue POST Request Example" })*/
			};
			console.log('STEP 1');
			await fetch(vm.$root.WEBURL+'/category', requestOptions).then( async response => {
				console.log(response.json());
				console.log('STEP 2');
				//next();
			})
			console.log('STEP 3');
		});
			
	},
	props: {
		metadata: { type: Object },
	},
	created() {
		/*fetch('test.json')
		.then(resp => resp.json())
		.then(items => {
		this.items = items;
		const descEl = document.querySelector('head meta[name="description"]');
		const titleEl = document.querySelector('head title');

		descEl.setAttribute('content', items[0]['meta-desc']);
		titleEl.textContent = items[0]['meta-title'];
		})*/
	},
	beforeCreate: function() {
        document.body.className = 'home';
    },
	components: {
        "top-header": Header,
		"top-footer": Footer,
		"product-swiper": ProductSwiper,
		"quickview": Quickview,
	},
	mounted(){
        this.initload();
        
	},
	data() {
		return{
			
			related_products: [],
			modal_data: {
				price: 0,
				special_price: 0
			},
            thumbnailProps: { blank: false, width: 80, height: 0, class: 'm1' },
            url: this.$root.WEBURL+'relatedproducts',
            fields: [
                { key: 'image', label: 'Image' },
				{ key: 'title', label: 'Title'},
                { key: 'price', label: 'Price', class: 'text-center' },
                { key: 'qty', label: 'Quantity', class: 'text-center' },
				{ key: 'action', label: 'Action', class: 'text-center' },
				{ key: 'total', label: 'Total', class: 'text-right'}
			],
		};
	},
	methods: {
		setData (err, post) {
			if (err) {
				this.error = err.toString()
			} else {
				this.metadata = post
			}
			console.log(JSON.stringify(post));
		},
		showQuickView(item){
			this.modal_data = Object.assign({}, item);
			this.share_data_qty = 1;
			this.$root.$emit('bv::show::modal', 'qv-modal')
		},
		initload(){
			var self = this;
			console.log('--------------------');
            console.log(JSON.stringify(self.$root.cart));
			self.axios.post(self.url, {
                accesskey: self.$session.get('access_key'),
                products: 1
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
                    self.share_info = response.data.result.share_record;
                    self.related_products = response.data.result.related_products;
                    //console.log(self.share_data);
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		}
	},
	metaInfo() {
		return{
			title: 'Alluraa Cart!',
			titleTemplate: null, //'%s | vue-meta Example App',
			meta: [
				{ charset: 'utf-8' },
				{ name: 'keywords', content: 'alluraa, alluraa cart' },
				{ name: 'description', content: this.metadata.description },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' }
			]
		}
	}
}
</script>